import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { ProStudioContext } from '../xstate/prostudio.xstate.types';
import { checkForErrors } from './check-for-errors';
import { getAssetsUrl } from './get-asset-url';

const updateBot = (
  selectedBot: NonNullable<ProStudioContext['selectedBot']>,
  assetUrl?: string
) => {
  return {
    ...selectedBot,
    assets: (selectedBot.assets as string[])?.map((id: string) => {
      if (typeof id === 'object') {
        return id;
      }

      return {
        id,
        url: assetUrl ? `${assetUrl}${id}` : undefined,
      };
    }),
  };
};

export const getBotWithAssets = async ({
  selectedBot,
  projectId,
}: {
  selectedBot: NonNullable<ProStudioContext['selectedBot']>;
  projectId: string;
}): Promise<NonNullable<ProStudioContext['selectedBot']>> => {
  const assetId =
    typeof selectedBot.assets?.[0] === 'string'
      ? selectedBot.assets[0]
      : (selectedBot.assets?.[0] as { id: string })?.id;

  if (!assetId) {
    return updateBot(selectedBot);
  }

  const assetResponse = await urqlGql.getAssetById({
    assetId: encodeURIComponent(assetId),
    botId: selectedBot.id || '',
    projectId,
  });

  checkForErrors(assetResponse);

  const assetUrl = getAssetsUrl(assetResponse.data?.getBotAssetById?.data.url);

  console.log('ASSET_DATA', assetResponse);

  return updateBot(selectedBot, assetUrl);
};
